import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

// ✅ Fetch Consultation History API
export const fetchConsultationHistory = createAsyncThunk(
  'consultations/history',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        '/consultation/consultation-history-list/'
      );
      console.log('✅ Consultation History API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error Fetching Consultation History:', error);
      return rejectWithValue(
        error.response?.data || 'Failed to fetch consultation history'
      );
    }
  }
);

const consultationHistorySlice = createSlice({
  name: 'consultationHistory',
  initialState: {
    data: [],
    count: 0,
    next: null,
    previous: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsultationHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchConsultationHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.results || [];
        state.count = action.payload.count;
        state.next = action.payload.next;
        state.previous = action.payload.previous;
      })
      .addCase(fetchConsultationHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default consultationHistorySlice.reducer;
